var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"pp-header",class:{'pp-header--fixed': _vm.fixed, 'color': _vm.color,}},[_c('div',{staticClass:"pp-header__prefix"},[_vm._t("prefix")],2),_c('div',{staticClass:"pp-header__title"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_c('div',{staticClass:"pp-header__suffix"},[_vm._t("suffix")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }